// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[3].use[1]!../node_modules/leaflet/dist/leaflet.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://cdnjs.cloudflare.com/ajax/libs/leaflet.draw/1.0.4/leaflet.draw.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#root {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;

  margin: 0;
  padding: 0;

  display: flex;
  flex-direction: column;
  min-height: 0;

  background: lightgray;
  overflow-y: hidden;
}

#map-container {
  height: 600px;
  flex-grow: 1;
}

#consoleToolbar {
  display: flex;
  align-items: center;
  background-color: #f8f9fa;
  container-type: inline-size;
}


/* Show large version and hide mini version of toolbar and by default (for old browsers) */
#lg-bar {
  display: flex;
}
#mini-bar {
  display: none;
}

/* for mobile/small-width. Not supported on old browsers. */
@container (max-width: 420px) {
  #lg-bar {
    display: none;
  }
  #mini-bar {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    padding: 15px 10px;
    text-transform: capitalize;
  }
  #mini-bar > div {
    margin: 2px 3px;
  }
}

/* for desktop/wide view. Not supproted on old browsers. */
@container (min-width: 420px) {
  #lg-bar {
    display: flex;
  }
  #mini-bar {
    display: none;
  }
}


#projection-btn-container {
  flex-grow: 0;
  padding: 0px 8px;
}

.appbar-tog-btn {
  padding: 4px 8px;
}

#coordContainer {
  padding: 4px 8px;
  border-collapse: separate;
  border-spacing: 0;
}

#coordContainer > thead > tr > th {
  border: 1px solid lightgray;
  padding: 1px 3px;
  color: #343a40;
  font-size: 12px;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  text-align: center;
  min-width: 60px;
}

#coordContainer > thead > tr > th:first-child {
  border-top-left-radius: 5px;
}
#coordContainer > thead > tr > th:last-child {
  border-top-right-radius: 5px;
  border-left-width: 0px;
}

#coordContainer > tbody > tr > td {
  border-width: 0 1px 1px 1px;
  border-style: solid;
  border-color: lightgray;
  color: #343a40;
  padding: 2px 3px 0px 3px;
  font-family: 'Courier New', Courier, monospace;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
}

#coordContainer > tbody > tr > td:first-child {
  border-bottom-left-radius: 5px;
}
#coordContainer > tbody > tr > td:last-child {
  border-left-width: 0px;
  border-bottom-right-radius: 5px;
}

/*
Controls the CSS for projection buttons when there is no available projection
*/

.disabled {
  opacity: 40%;
}

.leaflet-control-view-center {
  background-image: url("https://raw.github.com/pwldp/leaflet.viewcenter/master/icon-viewcenter.png");
}

.sidebar {
  box-shadow: 0px 6px 6px -3px rgba(0, 0, 0, 0.2),
    0px 10px 14px 1px rgba(0, 0, 0, 0.14), 0px 4px 18px 3px rgba(0, 0, 0, 0.12);
}

.sidebar-collapsed {
  width: 200px;
  height: 48px;
  background: #f8f9fa;
  border-radius: 5px;
  padding-left: 5px;
  padding-bottom: 2px;
  display: grid;
  grid-template-columns: auto 20px;
}

.sidebar-expanded {
  width: 800px;
  height: 98px;
  background: #f8f9fa;
  display: grid;
  grid-template-columns: auto 20px;
  border-radius: 5px;
}

.sidebar-button {
  font: bold 18px "Lucida Console", Monaco, monospace;
  cursor: pointer;
  text-align: center;
  display: flex;
  align-items: center;
}

.sidebar-expanded .sidebar-button {
  padding: 2px;
  cursor: pointer;
  text-align: center;
  display: flex;
  align-items: center;
  border: none;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border-left: thin solid #ccc;
  background-color: #fff;
}

.sidebar-collapsed .sidebar-button {
  font: bold 18px "Lucida Console", Monaco, monospace;
  margin-left: 5px;
  margin-bottom: -2px;
  padding: 2px;
  cursor: pointer;
  text-align: center;
  display: flex;
  align-items: center;
  border: none;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border-left: thin solid #ccc;
  background-color: #fff;
}

.sidebar-button:hover {
  background-color: #ccc;
}

.leaflet-marker-pane .leaflet-editing-icon {
  
  /* Smaller borderless markers */
  margin-left: -5px !important;
  margin-top: -5px !important;
  width: 10px !important;
  height: 10px !important;
  border: 0px solid #FFF !important;

  /* Crosshair markers for drawing shapes */
  --c: linear-gradient(#FFF 0 0) 50%;
  background:
    var(--c)/100% 12% no-repeat,
    var(--c)/12% 100% no-repeat;
}

/* Hides drawing tooltip */
.leaflet-draw-tooltip {
  visibility: hidden !important;
}`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAGA;;;EAGE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,WAAW;;EAEX,SAAS;EACT,UAAU;;EAEV,aAAa;EACb,sBAAsB;EACtB,aAAa;;EAEb,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,2BAA2B;AAC7B;;;AAGA,0FAA0F;AAC1F;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA,2DAA2D;AAC3D;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,mJAAmJ;IACnJ,kBAAkB;IAClB,0BAA0B;EAC5B;EACA;IACE,eAAe;EACjB;AACF;;AAEA,0DAA0D;AAC1D;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;;;AAGA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mJAAmJ;EACnJ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,wBAAwB;EACxB,8CAA8C;EAC9C,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;;CAEC;;AAED;EACE,YAAY;AACd;;AAEA;EACE,mGAAmG;AACrG;;AAEA;EACE;+EAC6E;AAC/E;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,mDAAmD;EACnD,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,4BAA4B;EAC5B,+BAA+B;EAC/B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,mDAAmD;EACnD,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,4BAA4B;EAC5B,+BAA+B;EAC/B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,+BAA+B;EAC/B,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,uBAAuB;EACvB,iCAAiC;;EAEjC,yCAAyC;EACzC,kCAAkC;EAClC;;+BAE6B;AAC/B;;AAEA,0BAA0B;AAC1B;EACE,6BAA6B;AAC/B","sourcesContent":["@import \"../node_modules/leaflet/dist/leaflet.css\";\n@import \"https://cdnjs.cloudflare.com/ajax/libs/leaflet.draw/1.0.4/leaflet.draw.css\";\n\nhtml,\nbody,\n#root {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n\n  margin: 0;\n  padding: 0;\n\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n\n  background: lightgray;\n  overflow-y: hidden;\n}\n\n#map-container {\n  height: 600px;\n  flex-grow: 1;\n}\n\n#consoleToolbar {\n  display: flex;\n  align-items: center;\n  background-color: #f8f9fa;\n  container-type: inline-size;\n}\n\n\n/* Show large version and hide mini version of toolbar and by default (for old browsers) */\n#lg-bar {\n  display: flex;\n}\n#mini-bar {\n  display: none;\n}\n\n/* for mobile/small-width. Not supported on old browsers. */\n@container (max-width: 420px) {\n  #lg-bar {\n    display: none;\n  }\n  #mini-bar {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n    padding: 15px 10px;\n    text-transform: capitalize;\n  }\n  #mini-bar > div {\n    margin: 2px 3px;\n  }\n}\n\n/* for desktop/wide view. Not supproted on old browsers. */\n@container (min-width: 420px) {\n  #lg-bar {\n    display: flex;\n  }\n  #mini-bar {\n    display: none;\n  }\n}\n\n\n#projection-btn-container {\n  flex-grow: 0;\n  padding: 0px 8px;\n}\n\n.appbar-tog-btn {\n  padding: 4px 8px;\n}\n\n#coordContainer {\n  padding: 4px 8px;\n  border-collapse: separate;\n  border-spacing: 0;\n}\n\n#coordContainer > thead > tr > th {\n  border: 1px solid lightgray;\n  padding: 1px 3px;\n  color: #343a40;\n  font-size: 12px;\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n  text-align: center;\n  min-width: 60px;\n}\n\n#coordContainer > thead > tr > th:first-child {\n  border-top-left-radius: 5px;\n}\n#coordContainer > thead > tr > th:last-child {\n  border-top-right-radius: 5px;\n  border-left-width: 0px;\n}\n\n#coordContainer > tbody > tr > td {\n  border-width: 0 1px 1px 1px;\n  border-style: solid;\n  border-color: lightgray;\n  color: #343a40;\n  padding: 2px 3px 0px 3px;\n  font-family: 'Courier New', Courier, monospace;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n}\n\n#coordContainer > tbody > tr > td:first-child {\n  border-bottom-left-radius: 5px;\n}\n#coordContainer > tbody > tr > td:last-child {\n  border-left-width: 0px;\n  border-bottom-right-radius: 5px;\n}\n\n/*\nControls the CSS for projection buttons when there is no available projection\n*/\n\n.disabled {\n  opacity: 40%;\n}\n\n.leaflet-control-view-center {\n  background-image: url(\"https://raw.github.com/pwldp/leaflet.viewcenter/master/icon-viewcenter.png\");\n}\n\n.sidebar {\n  box-shadow: 0px 6px 6px -3px rgba(0, 0, 0, 0.2),\n    0px 10px 14px 1px rgba(0, 0, 0, 0.14), 0px 4px 18px 3px rgba(0, 0, 0, 0.12);\n}\n\n.sidebar-collapsed {\n  width: 200px;\n  height: 48px;\n  background: #f8f9fa;\n  border-radius: 5px;\n  padding-left: 5px;\n  padding-bottom: 2px;\n  display: grid;\n  grid-template-columns: auto 20px;\n}\n\n.sidebar-expanded {\n  width: 800px;\n  height: 98px;\n  background: #f8f9fa;\n  display: grid;\n  grid-template-columns: auto 20px;\n  border-radius: 5px;\n}\n\n.sidebar-button {\n  font: bold 18px \"Lucida Console\", Monaco, monospace;\n  cursor: pointer;\n  text-align: center;\n  display: flex;\n  align-items: center;\n}\n\n.sidebar-expanded .sidebar-button {\n  padding: 2px;\n  cursor: pointer;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  border: none;\n  border-top-right-radius: 5px;\n  border-bottom-right-radius: 5px;\n  border-left: thin solid #ccc;\n  background-color: #fff;\n}\n\n.sidebar-collapsed .sidebar-button {\n  font: bold 18px \"Lucida Console\", Monaco, monospace;\n  margin-left: 5px;\n  margin-bottom: -2px;\n  padding: 2px;\n  cursor: pointer;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  border: none;\n  border-top-right-radius: 5px;\n  border-bottom-right-radius: 5px;\n  border-left: thin solid #ccc;\n  background-color: #fff;\n}\n\n.sidebar-button:hover {\n  background-color: #ccc;\n}\n\n.leaflet-marker-pane .leaflet-editing-icon {\n  \n  /* Smaller borderless markers */\n  margin-left: -5px !important;\n  margin-top: -5px !important;\n  width: 10px !important;\n  height: 10px !important;\n  border: 0px solid #FFF !important;\n\n  /* Crosshair markers for drawing shapes */\n  --c: linear-gradient(#FFF 0 0) 50%;\n  background:\n    var(--c)/100% 12% no-repeat,\n    var(--c)/12% 100% no-repeat;\n}\n\n/* Hides drawing tooltip */\n.leaflet-draw-tooltip {\n  visibility: hidden !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
